import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  // 拂晓蓝
  colorPrimary: '#1890ff',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: '', // 清空标题，只显示 logo
  pwa: true,
  logo: 'https://api.sc9.cn/storage/logo/20260416/5482ec837dd3d262643833e9f0372cf5.png',
  iconfontUrl: '',
  token: {
    // 参见ts声明，demo 见文档，通过token 修改样式
    //https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
    bgLayout: 'transparent',
    pageContainer: {
      colorBgPageContainer: 'transparent',
    },
    sider: {
      colorMenuBackground: 'transparent',
    },
  },
};

export default Settings;
